import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";



export const createIssue = async (data) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues`,
        data
    );
    return response.data;
};


export const updateIssue = async (data) => {
    const response = await gatewayInstance.put(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues`,
        data
    );
    return response.data;
};


export const getIssueById = async (id) => {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues/${id}`
    );
    return response.data;
};


export const searchIssues = async (data) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues/search`,
        data
    );
    return response.data;
};

export const getIssuesByIds = async (ids) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues/by-ids`,
        ids
    );
    return response.data;
};

export const deleteIssue = async (id) => {
    const response = await gatewayInstance.delete(
        `${SERVICE_ENDPOINT.TRANSPORT}/issues/${id}`
    );
    return response.data;
};

export const getIssueStatusHistory = async (issueId) => {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/fleet-status/type/2/reference/${issueId}`
    );
    return response.data;
};

export const createIssueStatus = async ({ issueId, fleetStatus, desc, author }) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/fleet-status?author=${author}`,
        {tfsStatusType: 2, tfsReferance: issueId, tfsFleetStatus: fleetStatus, tfsDescription: desc,
        }
    );
    return response.data;
};
